import { styled } from "styled-components";

import { OpenInNew } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";
import { TruncatedText } from "@similarweb/ui-components/foundations";

import { ensureHttpsPrefix } from "../../../../utils";

import { DetailsRow } from "./DetailsRow";
import { NaValue } from "./NaValue";

const LinkWithIcon = styled.a`
    display: flex;
    align-items: center;
    gap: 4px;
    min-width: 0;
    text-decoration: none;
    flex-wrap: nowrap;

    > *:first-child {
        min-width: 0;
        flex: 1;
    }

    svg {
        width: 16px;
        height: 16px;
        flex-shrink: 0;
        visibility: hidden;
    }

    &:hover svg {
        visibility: visible;
    }
`;

type NewTabLinkRowProps = {
    label: string;
    url: string | null | undefined;
};

export const NewTabLinkRow = ({ label, url }: NewTabLinkRowProps) => (
    <DetailsRow label={label}>
        {url ? (
            <LinkWithIcon
                href={ensureHttpsPrefix(url)}
                target="_blank"
                rel="noopener noreferrer"
            >
                <TruncatedText
                    fontVariant="input2"
                    color={colorsPalettes.blue[400]}
                >
                    {url}
                </TruncatedText>
                <OpenInNew
                    size="xs"
                    color={colorsPalettes.blue[400]}
                />
            </LinkWithIcon>
        ) : (
            <NaValue />
        )}
    </DetailsRow>
);
